import { isEmpty, max, min, reduce } from 'lodash';
import moment from 'moment';

export default function (experiences) {
  if (isEmpty(experiences)) return false;
  const twentyFiveYears = moment().diff(moment().subtract(25, 'years'));
  const datesList =
    reduce(experiences, (dates, currentExperience) => {
      dates.startDates.push(moment(currentExperience.employmentStart));
      dates.endDates.push(currentExperience.current ? moment() : moment(currentExperience.employmentEnd));
      return dates;
    }, { startDates: [], endDates: [] });

  // WAHV-2285: Count total years of experience from the applicant starts working.
  // It will include the gaps.
  const totalDuration = max(datesList.endDates).diff(min(datesList.startDates));

  return (totalDuration >= twentyFiveYears);
}

export const warningExperienceYears = 'You cannot move to the next section until you have completed at least 25 years of work experience';



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Experience/validateExperienceYears.js